var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.588379,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EFF5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 30.1718C14.7072 30.1718 10.4167 25.8813 10.4167 20.5885C10.4167 15.2956 14.7072 11.0051 20.0001 11.0051C25.293 11.0051 29.5834 15.2956 29.5834 20.5885C29.5834 25.8813 25.293 30.1718 20.0001 30.1718ZM16.6459 22.505V24.4217H19.0417V26.3384H20.9584V24.4217H21.9167C23.2399 24.4217 24.3126 23.3491 24.3126 22.0259C24.3126 20.7027 23.2399 19.6301 21.9167 19.63H18.0834C17.9122 19.63 17.754 19.5387 17.6684 19.3905C17.5828 19.2422 17.5828 19.0596 17.6684 18.9113C17.754 18.763 17.9122 18.6717 18.0834 18.6717H23.3542V16.755H20.9584V14.8384H19.0417V16.755H18.0834C16.7602 16.755 15.6876 17.8277 15.6876 19.1509C15.6876 20.4741 16.7602 21.5467 18.0834 21.5467H21.9167C22.0879 21.5467 22.2461 21.638 22.3317 21.7863C22.4173 21.9346 22.4173 22.1172 22.3317 22.2655C22.2461 22.4137 22.0879 22.505 21.9167 22.505H16.6459Z",
    fill: "#64A0E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/PriceIcon.aba20daa9586beec7d027b3a47cd1c63.svg";
export { ForwardRef as ReactComponent };